import { CLASS_ANSWER_STATEMENT, CLASS_FOOTER_TOTAL_VOTES, meiroEvents } from './enquiryCommons';

import { setCookie } from '../cookieHelpers';
import showLoginLink from './showLoginLink';
import { vote } from './enquiryApi';
import { checkDataError, checkResponseError, handleError } from './errorHandling';
import showResult from './showResult';
import voteWord from './voteWord';

/**
 * @name handleVote
 * @description Odešle hlas na server a podle odpovědi zobrazí výsledky, pokud je uživatel přihlášen.
 * Pokud ne, zobrazí výzvu k přihlášení. Ukládá cookie s informací, že uživatel již hlasoval..
 *
 * @param {Boolean} isLogged True pokud je uživatel přihlášen.
 * @param {Boolean} [enquiryVotingDisabled=false] Změní text, pokud je anketa ukončená.
 * @param {HTMLElement} enquiry Element ankety.
 * @param {String} enquiryId Identifikátor ankety.
 * @param {String} questionId Identifikátor odpovědi.
 * @param {String} questionText Text odpovědi.
 * @param {HTMLElement} answersWrapper Element obalující všechny odpovědi.
 * @param {NodeListOf<Element>} answers Elementy odpovědí.
 * @param {HTMLElement} voteNotice Element pro potvrzení přijetí hlasu.
 * @param {Function} voteHandlerListener Callback.
 * @param {Event} event
 * @returns {Promise<void>}
 */
const handleVote = async (
  isLogged,
  enquiryVotingDisabled,
  enquiry,
  enquiryId,
  questionId,
  questionText,
  answersWrapper,
  answers,
  voteNotice,
  voteHandlerListener,
  event
) => {
  event.preventDefault();
  const targetElement = event.target;

  if (targetElement.classList.contains(CLASS_ANSWER_STATEMENT)) {
    // Po kliknutí na vybranou odpověď se odstraní event listener pro všechny odpovědi, nastaví se hláška pro uživatele a uloží data o vybrané odpovědi ze šablony.
    answersWrapper.removeEventListener('click', voteHandlerListener);
    const { answerId, answerText } = targetElement.parentElement.dataset;

    // Neposíláme hlas, pokud hlasování skončilo.
    if (enquiryVotingDisabled) {
      // Ukládáme cookie stejně, jako kdyby uživatel hlasoval kvůli jednotnosti.
      setCookie(`enquiry-${questionId}`, 'votingEnded', 7);

      // Pokud je uživatel přihlášen, zobrazí se výsledky odpovědí už v twigové šabloně. Pokud ne, tak zobrazíme výzvu k přihlášení.
      showLoginLink(
        enquiry,
        answersWrapper,
        voteNotice,
        questionId,
        questionText,
        enquiryVotingDisabled
      );
    } else {
      voteNotice.innerText = 'Odesílání hlasu...';

      // Odeslání hlasu a zobrazení výsledků nebo výzvy k přihlášení v závislosti na tom, zda je uživatel přihlášen.
      try {
        const response = await fetch(vote(answerId, questionId));
        checkResponseError(response.status);
        const jsonData = await response.json();
        checkDataError(jsonData.ok);

        // V případě úspěšného odeslání hlasu se informace o anketě a vybrané odpovědi uloží do cookie.
        // Cookie má platnost 7 dní, po tu dobu uživatel nemůže hlasovat znovu.
        setCookie(`enquiry-${questionId}`, answerId, 7);
        const selectedAnswerServer = jsonData.id;
        const questionData = jsonData.data[selectedAnswerServer][jsonData.eid];

        // Pokud je uživatel přihlášen, rovnou se zobrazí výsledky - použijí se data, která přijdou jako odpověď po odeslání hlasu.
        // Pokud ne, zobrazí se výzva k přihlášení.
        if (isLogged) {
          answers.forEach((answer) => {
            const percent = `${Math.round(questionData[answer.dataset.answerId].qperc_val)}%`;
            voteNotice.innerText = '';
            showResult(answer, percent, answerId);
          });
        } else {
          showLoginLink(
            enquiry,
            answersWrapper,
            voteNotice,
            questionId,
            questionText,
            enquiryVotingDisabled
          );
        }

        const votesTotalServer = jsonData.data[selectedAnswerServer].total;

        enquiry.querySelector(
          `.${CLASS_FOOTER_TOTAL_VOTES}`
        ).innerText = `Celkově ${votesTotalServer} ${voteWord(votesTotalServer)}`;

        if (meiroEvents) {
          meiroEvents.track('customEvent', {
            action: `poll voted: ${questionText}`,
            answer: answerText,
          });
        }

        if (window.dataLayer && window.didomiOnReady !== undefined) {
          void window.dataLayer.push({
            event: 'form_input_success',
            form: {
              id: answerId,
              name: questionText,
              result: answerText,
            },
          });
        }
      } catch (err) {
        handleError(err.message, voteNotice);
      }
    }
  }
};

export default handleVote;
